<template>
<Login></Login>
</template>

<script>
import Login from "@/components/Login.vue";
export default {
  name: 'LoginView',
  data() {
    return {}
  },
  components: {
    Login
  },
}

</script>

<style scoped>

</style>